// extracted by mini-css-extract-plugin
module.exports = {"container":"_eWVzGQUv","footer":"_3ECxcjJk"};